const common = {
  Loading: "جار التحميل",
  signUp: "إنشاء حساب",
  login: "تسجيل الدخول",
  logout: "تسجيل الخروج",
  email: "البريد الإلكتروني",
  emailFormatErrorTips: "صيغة البريد الإلكتروني غير صحيحة",
  emailDifferentTips: "يرجى إدخال نفس البريد الإلكتروني في كلا الخانتين.",
  emailRegisteredTips: "هذا البريد الإلكتروني مسجل، يرجى استخدام بريد آخر.",
  password: "كلمة السر",
  passwordFormatErrorTips: "يجب أن تتكون كلمة السر من 8 – 50 حرفًا وتحتوي على فئتين على الأقل من الآتي: رقم، حرف أو حرف خاص.",
  passwordDifferentTips: "يرجى إدخال نفس كلمة السر في كلا الخانتين.",
  verificationCode: "رمز التحقق",
  verificationCodeErrorTips: "رمز التحقق غير صحيح",
  confirm: "تأكيد",
  cancel: "إلغاء",
  submit: "إرسال",
  confirmEmail: "تأكيد البريد الإلكتروني",
  formEmptyErrorTips: "لا يمكن أن يكون هذا فارغًا",
  country: "البلد/ المنطقة",
  birthday: "عيد الميلاد",
  anonymous: "مجهول",
  name: "الاسم",
  nameFormatErrorTips: "يجب ألا يزيد اسم المستخدم عن 50 حرفًا وألا يحتوي على حروف خاصة",
  okBtn: "حسنًا",
  serverErrorTips: "عذراً، قد حدث خطأ ما. يرجى إعادة المحاولة لاحقاً.",
  updateSuccessTips: "التغيير بنجاح",
  authorizationExpiredErrorTips: "انتهت صلاحية التفويض، يرجى تسجيل الدخول مرة أخرى.",
  requestFrequentlyErrorTips: "تم إرسال عدد كبير من الطلبات نفسها في فترة زمنية قصيرة، يرجى المحاولة مرة أخرى لاحقًا.",
  GetCode:'الحصول على رمز'
};

export default common;
